import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { InterestDialogComponent } from './interest-dialog/interest-dialog.component';
import { PostFeedDialogComponent } from './post-feed-dialog/post-feed-dialog.component';
import { DoctorSocialService } from './doctor-social.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PostDetailsPopUpComponent } from './post-details-pop-up/post-details-pop-up.component';
import { environment } from 'src/environments/environment';
import { FeedOptionsDialogComponent } from './feed-options-dialog/feed-options-dialog.component';
import { getLinkPreview } from "link-preview-js";
import { StoryDetailsDialogComponent } from './story-details-dialog/story-details-dialog.component';
import { LikesListDialogComponent } from './likes-list-dialog/likes-list-dialog.component';
import { fadeUpAnimation } from './post-details-pop-up/animations';
import { OthersFeedOptionsDialogComponent } from './others-feed-options-dialog/others-feed-options-dialog.component';
import { InsightsDialogComponent } from './insights-dialog/insights-dialog.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { UserSearchHistoryService } from './search-history.service';
import { LoginDialogComponent } from 'src/app/patients/doctor-profile/components/login-dialog/login-dialog.component';
import { OptionsForModComponent } from './options-for-mod/options-for-mod.component';

@Component({
  selector: 'app-doctor-social',
  templateUrl: './doctor-social.component.html',
  styleUrls: ['./doctor-social.component.css'],
  animations: [fadeUpAnimation]
})
export class DoctorSocialComponent implements OnInit, OnDestroy {

  searchInput = new FormControl("")
  Posts: any[] = [];
  PostsForSSR: any[] = [];
  promotedPostSSR = null

  stories: any[] = [];
  Ads;

  searchOptions: any[] = [];

  form: FormGroup;
  basePathImage: string = environment.imageBaseUrl;

  notificationsTap: boolean = false
  totalResultNotifications: number = 0
  notificationsRes;

  totalResult: number = 0
  addScrollListener = () => window.addEventListener('scroll', this.onScrolling);
  removeScrollListener = () => window.removeEventListener('scroll', this.onScrolling);

  constructor(
    public app: AppService,
    public router: Router,
    public dialog: MatDialog,
    private service: DoctorSocialService,
    @Inject(DOCUMENT) private document: any,
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private clipboard: Clipboard,
    private userHistorySearchService: UserSearchHistoryService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.getPromotedPosts(1);
    }
  }
  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.removeScrollListener();
    }
  }
  ngOnInit(): void {
    this.slideConfig();
    this.form = new FormGroup({
      ListType: new FormControl(0),
      PageSize: new FormControl(6),
      PageNumber: new FormControl(1),
    });
    if (isPlatformServer(this.platformId)) {
      this.getPostsForSSR();
      return
      this.getPromotedPostForSSR();
    }
    if (isPlatformBrowser(this.platformId)) {
      this.refreshSearchHistory();
      this.checkUrlParams();
      setTimeout(() => {
        this.scrollToTop();
        this.getPosts();
      }, 800);
      if (this.app.getUserData()) {
        this.getStories();
        if (this?.app?.isDoctor || this?.app?.isPatient) {
          this.getMyInterestsCategories();
        }
      }
    }
    this.getAds();
  }

  get = (formControlName: string) => this.form.get(formControlName) as FormControl;

  deleteOptionFromSearchHistory(index) {
    this.userHistorySearchService.removeUserSearchHistory(index)
    setTimeout(() => {
      this.searchInput.setValue(null)
      this.refreshSearchHistory();
    }, 100);
  }

  refreshSearchHistory() {
    if (this.searchOptions.length) {
      this.searchOptions.length = 0
    }
    setTimeout(() => {
      this.searchOptions = this?.userHistorySearchService?.getUserSearchHistory()
    }, 100);
  }

  getPostsForSSR() {
    let request = {
      "pageSize": 7,
      "pageNumber": 1
    }
    this.service.searchPostsListSSR(request).subscribe(
      async res => {
        this.PostsForSSR = res?.data?.data
      }
    )
  }

  getPromotedPostForSSR() {
    return
    let request = new FormData();
    request.append("SearchKeyword", this.searchInput.value);
    request.append("PageSize", "1");
    request.append("PageNumber", "1");
    request.append("isPromoted", "true");
    this.service.searchPosts(request).subscribe(
      async res => {
        if (res?.data?.data?.length > 0) {
          this.promotedPostSSR = res?.data?.data
        }
      }
    )
  }

  // promotedPosts
  totalRowPromotedPosts = 0;
  promotedPostsIncluded = 1;
  promotedPosts: any[] = [];
  async getPromotedPosts(pageNumber) {
    let request = new FormData();
    request.append("SearchKeyword", this.searchInput.value);
    request.append("PageSize", "1");
    request.append("PageNumber", pageNumber as string);
    request.append("isPromoted", "true");

    await this.service.searchPosts(request).subscribe(
      async res => {
        this.totalRowPromotedPosts = res?.data?.data?.totalRows
        this.promotedPosts = res?.data?.data
        // res?.data?.data.forEach(element => {
        //   this.promotedPosts.push(element)
        // });
      }
    )
  }
  // promotedPosts

  getRequestPayLoad = (): Promise<FormData> => {
    let request = new FormData();
    request.append("SearchKeyword", this.searchInput.value);
    request.append("ListType", this.get("ListType").value as string);
    request.append("PageSize", this.get("PageSize").value);
    request.append("PageNumber", this.get("PageNumber").value as string);
    return Promise.resolve(request) as Promise<FormData>;
  }

  getPosts = async (): Promise<void> => {
    this.app.showLoading();
    this.Posts.length = 0
    this.get("PageSize").setValue(6);
    this.get("PageNumber").setValue(1);
    await this.service.searchPosts(await this.getRequestPayLoad()).subscribe(
      async res => {
        if (res.errorCode == 0) {
          if (res.data.data.length) {

            if (this?.searchInput?.value?.length > 0) {
              this?.userHistorySearchService.setUserSearchHistory(this?.searchInput?.value)
              setTimeout(() => {
                // if(!this.searchOptions.includes(this?.searchInput?.value)){
                //   this.searchOptions.unshift(this?.searchInput?.value)
                // }
                this.refreshSearchHistory();
              }, 300);
            }

            // HandlesPromotedPosts
            if (this.promotedPosts.length) {
              await Promise.all(this?.promotedPosts?.map(async item => {
                if (item?.postMedia && item?.postMedia[0]?.mediaType === 3) {
                  const transformedItem = await this.urlChangeInput(item);
                  this.Posts.push(transformedItem)
                  this.promotedPostsIncluded = this.promotedPostsIncluded + 1
                } else {
                  this.Posts.push(item)
                  this.promotedPostsIncluded = this.promotedPostsIncluded + 1
                }
                this.promotedPosts.length = 0
                if (this.totalRowPromotedPosts != this.promotedPostsIncluded) {
                  this.getPromotedPosts(this.promotedPostsIncluded)
                }
              }));
            }
            // HandlesPromotedPosts

            const processedPosts = await Promise.all(res?.data?.data?.map(async item => {
              this?.app?.isMostlyEnglish(item?.postText) == true ? item.textDirection = "ltr" : item.textDirection = "rtl"
              if (item?.postMedia && item?.postMedia[0]?.mediaType === 3) {
                const transformedItem = await this.urlChangeInput(item);
                return transformedItem;
              }
              return item;
            }));
            this.Posts.push(...processedPosts);
            this.totalResult = res.data.totalRows;
          } else if (!res.data.data.length) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.info("Nothing Found");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.info("لم يتم العثور على بيانات");
            }
            setTimeout(() => {
              this.searchInput.setValue('')
              // this.getPosts();
            }, 800);
          }
        }
        this.app.dismissLoading();
      }
    )
    setTimeout(() => this.addScrollListener(), 750)
  }

  async getPostsForScroll() {
    this.app.showLoading();
    this.service.searchPosts(await this.getRequestPayLoad()).subscribe(
      async res => {
        if (res.errorCode == 0) {
          if (this.Posts.length) {

            let nextValues = res.data.data;
            const totalRows = res.data.totalRows;
            let withLastValues = this.Posts.concat([...nextValues]);

            // HandlesPromotedPosts
            if (this.promotedPosts.length) {
              await Promise.all(this?.promotedPosts?.map(async item => {
                if (item?.postMedia && item?.postMedia[0]?.mediaType === 3) {
                  const transformedItem = await this.urlChangeInput(item);
                  this.Posts.push(transformedItem)
                  this.promotedPostsIncluded = this.promotedPostsIncluded + 1
                } else {
                  this.Posts.push(item)
                  this.promotedPostsIncluded = this.promotedPostsIncluded + 1
                }
                this.promotedPosts.length = 0
                if (this.totalRowPromotedPosts != this.promotedPostsIncluded) {
                  this.getPromotedPosts(this.promotedPostsIncluded)
                }
              }));
            }
            // HandlesPromotedPosts

            // if search result count less that current objects
            if (totalRows < withLastValues.length) {
              // this.Posts = (nextValues);
              await this.processItems(nextValues)
            } else {
              await this.processItems(nextValues)
              // this.Posts = (withLastValues);
            }
            // this.isLoaded = true;
          } else {
            const processedPosts = await Promise.all(res?.data?.data?.map(async item => {
              this?.app?.isMostlyEnglish(item?.postText) == true ? item.textDirection = "ltr" : item.textDirection = "rtl"
              if (item?.postMedia && item?.postMedia[0]?.mediaType === 3) {
                const transformedItem = await this.urlChangeInput(item);
                return transformedItem;
              }
              return item;
            }));
            this.Posts.push(...processedPosts);
            // this.Posts = res.data.data;
          }
          this.totalResult = res.data.totalRows;
          if (this.Posts.length == 0) {
            if (res.data.data.length == 0) {
              if (this?.app?.getUserLanguage() == 'en') {
                this.toaster.info("Nothing Found");
              } else if (this?.app?.getUserLanguage() == 'ar') {
                this.toaster.info("لم يتم العثور على بيانات");
              }
            }
          }
        }
        this.app.dismissLoading();
      }
    )
    setTimeout(() => this.addScrollListener(), 750)
  }

  async processItems(items) {
    if (!items) { return }
    const processedPosts = await Promise.all(items.map(async item => {
      this?.app?.isMostlyEnglish(item?.postText) == true ? item.textDirection = "ltr" : item.textDirection = "rtl"
      if (item?.postMedia && item?.postMedia[0]?.mediaType == 3) {
        const transformedItem = await this.urlChangeInput(item);
        return transformedItem;
      }
      return item;
    }));

    this.Posts.push(...processedPosts);
  }



  // SlideSettings
  slideConfig() {
    if (this?.app?.getUserLanguage() == 'ar') {
      this.slideConfigureForDoctor.rtl = true
    }
  }

  slideConfigureForDoctor = {
    dots: false,
    autoplay: false,
    infinite: false,
    variableWidth: true,
    draggable: false,
    rtl: false,
    arrows: true,
    // slidesToShow: auto,
  };



  postDetailsPopUp(id, index) {
    const dialogRef = this.dialog.open(PostDetailsPopUpComponent, {
      width: '100%',
      data: { id, index },
      panelClass: 'custom-modalBox',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == "delete") {
        this.Posts = this.Posts.filter(item => item?.postId !== id);
      } else if (res == "edit") {
        this.service.getPostById(id).subscribe(
          res => {
            if (res.errorCode == 0) {
              let obj = res?.data
              const index = this.Posts.findIndex(item => item?.postId == id);
              if (index != -1) {
                this.Posts[index] = obj
              }
              this.postDetailsPopUp(id, null)
            }
          }
        )
      } else if (res == "like") {
        this.service.getPostById(id).subscribe(
          res => {
            if (res.errorCode == 0) {
              let obj = res?.data
              const index = this.Posts.findIndex(item => item?.postId == id);
              if (index != -1) {
                this.Posts[index] = obj
              }
            }
          }
        )
      }
    });

  }

  notifications() {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (!this?.notificationsRes) {
      let PageSize = 20
      let PageNumber = 1
      this.service.getNotifications(PageSize, PageNumber).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.notificationsRes = res?.data?.data
            this.totalResultNotifications = res?.totalRows
          }
        }
      )
    }

    this.notificationsTap == true ? this.notificationsTap = false : this.notificationsTap = true
  }

  postPopUp() {
    // if (!this?.app?.isDoctor || !this?.app?.isContributor) { return }
    const dialogRef = this.dialog.open(PostFeedDialogComponent, {
      width: '33%',
      data: {},
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {
        this.getPosts();
      }
    });
  }

  editPostPopUp(id, isMyPost) {
    if (this?.app?.IsSocialMediaManager) {
      const dialogRef = this.dialog.open(OptionsForModComponent, {
        width: '600px',
        data: id,
        panelClass: 'option-dialog',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res == "delete") {
          this.Posts = this.Posts.filter(item => item?.postId != id);
        } else if (res == "edit") {
          this.service.getPostById(id).subscribe(
            res => {
              if (res.errorCode == 0) {
                let obj = res?.data
                const index = this.Posts.findIndex(item => item?.postId == id);
                if (index != -1) {
                  this.Posts[index] = obj
                }
              }
            }
          )
        }
      });
    } else {
      if (isMyPost == true) {
        const dialogRef = this.dialog.open(FeedOptionsDialogComponent, {
          width: '600px',
          data: id,
          panelClass: 'option-dialog',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(res => {
          if (res == "delete") {
            this.Posts = this.Posts.filter(item => item?.postId != id);
          } else if (res == "edit") {
            this.service.getPostById(id).subscribe(
              res => {
                if (res.errorCode == 0) {
                  let obj = res?.data
                  const index = this.Posts.findIndex(item => item?.postId == id);
                  if (index != -1) {
                    this.Posts[index] = obj
                  }
                }
              }
            )
          }
        });
      } else {
        const dialogRef = this.dialog.open(OthersFeedOptionsDialogComponent, {
          width: '600px',
          data: id,
          panelClass: 'option-dialog',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(res => {
        });
      }
    }
  }

  likesPopUp(id, likeCount, type) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (likeCount == 0) { return }
    let req = {
      id: id,
      type: type,
    }
    const dialogRef = this.dialog.open(LikesListDialogComponent, {
      width: '470px',
      data: req
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  routeToDocProfile(doc) {
    let docObj = {
      fullName: doc?.creatorName,
      speciality: doc?.creatorSpeciality,
      id: doc?.hcpRequestId,
    }
    this.app.routeToDoctorProfile(docObj)
  }

  likeDislikePost(postId, likeStatus, index) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (likeStatus == false) {
      this.service.likePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.Posts[index].likesCount = this.Posts[index].likesCount + 1
            this.Posts[index].iLikedPost = true
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (likeStatus == true) {
      this.service.unlikePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {

            this.Posts[index].likesCount = this.Posts[index].likesCount - 1
            this.Posts[index].iLikedPost = false

          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  commentsPopUp() {
    console.warn("commentsPopUp")
  }

  chartPopUp(id, myPost) {
    // let id = this?.data
    if (myPost == false) { return }
    const dialogRef = this.dialog.open(InsightsDialogComponent, {
      width: '700px',
      data: { id },
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {

      }
    });
  }

  arrowPopUp(id) {
    let req = {
      "dynamicLinkInfo": {
        "domainUriPrefix": `https://ihospitalapp.page.link`,
        "link": `https://www.ihospitalapp.com/en/Tebgram/post/${id}`,
        "androidInfo": {
          "androidPackageName": "com.technzone.ihospital"
        },
        "iosInfo": {
          "iosBundleId": "com.technzone.ihospitalapp"
        }
      }
    }
    this.service.createDynamicLink(req).subscribe(
      res => {
        let link = res?.shortLink
        this.clipboard.copy(link);
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.info("Link Copied");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.info("تم نسخ الرابط");
        }
      }
    )
  }

  getStories = async (): Promise<void> => {
    this.service.getStories().subscribe(
      async res => {
        const reStories: any[] = [];
        await Promise.all(res?.data?.data?.map(async item => {
          let jab = reStories?.find(x => x?.creatorId == item?.creatorId)
          if (jab) {
            let jabIndex = reStories?.indexOf(jab);
            reStories[jabIndex]?.storiesAttr?.push(
              {
                "postId": item?.postId,
                "iViewdStory": item?.iViewdStory,
              }
            )
          } else {
            reStories.push(
              {
                "creatorId": item?.creatorId,
                "creatorPicture": item?.creatorPicture,
                "creatorName": item?.creatorName,
                "iViewdStory": null,
                "storiesAttr": [
                  {
                    "postId": item?.postId,
                    "iViewdStory": item?.iViewdStory,
                  }
                ]
              }
            )
          }
          // if (item?.iViewdStory == true) {
          //   this?.stories?.push(item);
          // } else if (item?.iViewdStory == false) {
          //   this?.stories?.unshift(item);
          // }
        }));
        await Promise.all(reStories?.map(async item => {
          const allViewed = item?.storiesAttr?.every(item => item?.iViewdStory);
          if (allViewed == true) {
            item.iViewdStory = true
            this?.stories?.push(item);
          } else if (allViewed == false) {
            item.iViewdStory = false
            this?.stories?.unshift(item);
          }
        }));
      }
    )
  }

  openStory(index) {
    const storysIds = this?.stories
    if (index >= 0 && index < this?.stories.length) {
      storysIds.splice(0, index);
    }
    const dialogRef = this.dialog.open(StoryDetailsDialogComponent, {
      width: '80%',
      data: { index, storysIds },
      panelClass: 'custom-modalBox'
    });
    dialogRef.afterClosed().subscribe(res => {
      this.stories.length = 0
      this.getStories();
    });

  }

  onScrolling = () => {
    if (this.totalResult <= this.Posts.length || this?.app?.isLoading == true) { return }
    if (~~(Number($(window).scrollTop())) + Number($(window).height()) > Number($(this.document).height()) - 400) {
      this.removeScrollListener();
      this.app.showLoading();
      this.get('PageNumber')?.setValue(Number(this.get('PageNumber')?.value) + 1);
      this.getPostsForScroll();
      // setTimeout(() => this.app.dismissLoading(), 750)
    }
  }

  checkUrlParams() {
    let params = this.route.queryParams['_value'];
    if (params?.feedId) {
      this.postDetailsPopUp(params?.feedId, null);
    } else if (params?.searchInput) {
      this.searchInput.setValue(params?.searchInput)
      this.removeParamsFromUrl();
    }
  }

  getTimeDifferenceString(dateStr: string): string {
    const currentDate = new Date();
    const targetDate = new Date(dateStr);

    const timeDifferenceInMilliseconds = currentDate.getTime() - targetDate.getTime();
    const timeDifferenceInSeconds = Math.floor(timeDifferenceInMilliseconds / 1000);
    const timeDifferenceInMinutes = Math.floor(timeDifferenceInSeconds / 60);
    const timeDifferenceInHours = Math.floor(timeDifferenceInMinutes / 60);
    const timeDifferenceInDays = Math.floor(timeDifferenceInHours / 24);

    if (this.app.languageCode == 'en') {
      if (timeDifferenceInDays > 0) {
        return `${timeDifferenceInDays} day${timeDifferenceInDays > 1 ? 's' : ''} ago`;
      } else if (timeDifferenceInHours > 0) {
        return `${timeDifferenceInHours} hour${timeDifferenceInHours > 1 ? 's' : ''} ago`;
      } else if (timeDifferenceInMinutes > 0) {
        return `${timeDifferenceInMinutes} minute${timeDifferenceInMinutes > 1 ? 's' : ''} ago`;
      } else {
        return 'Just now';
      }
    } else {
      if (timeDifferenceInDays > 0) {
        return `قبل ${timeDifferenceInDays > 1 ? timeDifferenceInDays : ''} ${timeDifferenceInDays > 1 ? 'ايام' : 'يوم'}`;
      } else if (timeDifferenceInHours > 0) {
        return `قبل ${timeDifferenceInHours > 1 ? timeDifferenceInHours : ''} ${timeDifferenceInHours > 1 ? 'ساعات' : 'ساعة'}`;
      } else if (timeDifferenceInMinutes > 0) {
        return `قبل ${timeDifferenceInMinutes > 1 ? timeDifferenceInMinutes : ''} ${timeDifferenceInMinutes > 1 ? 'دقائق' : 'دقيقة'}`;
      } else {
        return 'الآن';
      }
    }
  }

  async urlChangeInput(item) {
    try {
      const itemData = item
      const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
      if (urlPattern.test(itemData?.postMedia[0]?.mediaFilePath)) {
        // await getLinkPreview(itemData?.postMedia[0]?.mediaFilePath).then((data) => {
        //   const resData: any = data
        //   if (resData?.description) {
        //     let modifiedData = {
        //       mediaFilePath: itemData?.postMedia[0]?.mediaFilePath,
        //       mediaType: itemData?.postMedia[0]?.mediaType,
        //       mimeType: itemData?.postMedia[0]?.mimeType,
        //       urlImage: resData?.images[0],
        //       urlDescription: resData?.description
        //     }
        //     itemData.postMedia[0] = modifiedData
        //   }
        // });
        await this.service.getLinkPreviewData(itemData?.postMedia[0]?.mediaFilePath).subscribe(
          res => {
            let modifiedData = {
              mediaFilePath: itemData?.postMedia[0]?.mediaFilePath,
              mediaType: itemData?.postMedia[0]?.mediaType,
              mimeType: itemData?.postMedia[0]?.mimeType,
              urlTitle: res?.title,
              urlImage: res?.image,
              urlDescription: res?.description
            }
            itemData.postMedia[0] = modifiedData
          }
        )
      }
      return itemData
    } catch (error) {
      console.error('An error occurred:', error);
      return item
    }
  }

  urlClicked(url) {
    window.open(url)
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }


  switchOnClick(e) {
    if (this?.app?.isLoading == true || e == this.selectedButton) { return }
    this.scrollToTop();
    switch (e) {
      case 'all':
        this.get("ListType").setValue(0)
        this.selectedButton = e
        this.getPosts();
        break;
      case 'forYou':
        this.get("ListType").setValue(1)
        this.selectedButton = e
        this.getPosts();
        break;
    }
  }


  interestedCategories;
  selectedButton: "all" | "forYou" = "all"
  switchListInterest: boolean = false
  getMyInterestsCategories() {
    this.service.getInterestsRelatedToUser().subscribe(
      async res => {
        if (res.errorCode == 0) {
          if (res?.data?.length == 0) {
            this.interestPopUp()
          } else {
            this.interestedCategories = res.data
            this.switchListInterest = true
          }
        }
      }
    )
  }

  interestPopUp() {
    const dialogRef = this.dialog.open(InterestDialogComponent, {
      width: '600px',
      data: {},
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {
        this.getMyInterestsCategories();
      }
    });
  }

  getAds() {
    this.service.getAds(30, 1).subscribe(
      res => {
        this.Ads = res.data.data
      }
    )
  }

  removeParamsFromUrl() {
    this.router.navigate([], {
      queryParams: {
        'searchInput': null,
      },
      queryParamsHandling: 'merge'
    });
  }

  notLoggedInDialog() {
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '350px',
      data: {},
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  openUrlAd(url) {
    if (!url) { return }
    window.open(url, '_blank');
  }

}
